<template>
  <aside
    :class="
      {
        info: 'bg-blue-100 text-blue-700',
        success: 'bg-green-200 text-green-900',
        error: 'bg-red-100 text-red-700',
        warning: 'bg-yellow-50 text-yellow-700',
      }[urgency]
    "
    class="relative grid grid-cols-2 p-4"
  >
    <div>
      <div class="flex items-start justify-between">
        <div class="grid">
          <strong v-if="$slots.title" class="-mt-0.5 text-lg/5">
            <slot name="title" />
          </strong>
          <span v-if="created" class="text-xs font-medium">
            {{ format(new Date(created), "MMM d, yyyy") }}
          </span>
        </div>
      </div>
      <slot />
    </div>
    <button
      class="p-2 place-items-end text-end rounded-md text-inherit cursor-pointer bg-transparent"
      aria-label="Close"
      @click="siteNotificationStore.removeNotification(props.pk)"
    >
      <Xmark class="w-4" />
    </button>
  </aside>
</template>

<script setup>
import { format } from "date-fns";
import Xmark from "@/components/icons/Xmark.vue";
import useSiteNotificationStore from "@/stores/site-notifications";

const siteNotificationStore = useSiteNotificationStore();

const props = defineProps({
  pk: { type: Number, required: true },
  urgency: { type: String, required: true },
  created: { type: String, required: true },
});
</script>
